import { render } from "./Commerce1.vue?vue&type=template&id=d9abf6a0"
import script from "./Commerce1.vue?vue&type=script&lang=js"
export * from "./Commerce1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__